import { FC, createContext, useContext, useState } from "react";

interface FeatureProviderProps {
  children: React.ReactNode;
}

export const FeatureContext = createContext({
  isShow: false,
  setShowFeature: (_value: boolean) => {},
});

const FeatureProvider: FC<FeatureProviderProps> = ({ children }) => {
  const [isShow, setShowFeature] = useState(false);
  return (
    <FeatureContext.Provider value={{ isShow, setShowFeature }}>
      {children}
    </FeatureContext.Provider>
  );
};

export function useFeature() {
  const context = useContext(FeatureContext);
  if (!context) {
    throw new Error("useLoading must be used within LoadingProvider");
  }
  return context;
}

export default FeatureProvider;